export default __webpack_public_path__ + "static/media/049-llama.35dda401.svg";